import { computed, Directive, input } from '@angular/core';

type ButtonSize = 'XS' | 'S' | 'M' | 'L';

export const enum FilledFlavor {
	DEFAULT = 'DEFAULT',
	WARNING = 'WARNING',
}

const BUTTON_CLASS_BY_SIZE: Record<ButtonSize, string> = {
	XS: 'pr-1 pl-2 py-0.5 rounded-0.75 gap-0.5',
	S: 'pr-1.5 pl-2 py-0.75 rounded-1 gap-0.75',
	M: 'px-2 py-1 rounded-1 gap-1',
	L: 'px-2 py-1 rounded-1 gap-1',
};

@Directive({
	selector: '[buttonOutlined]',
	standalone: true,
	host: {
		class: 'border text-m flex items-center justify-center',
		'[class.hover:bg-standard-hover]': '!$disabled()',
		'[class.border-line-230]': '!$disabled() && !$flavorIsWarning()',
		'[class.fc-800]': '!$disabled() && $flavorIsDefault()',
		'[class.border-line-250]': '$disabled()',
		'[class.text-warn]': '!$disabled() && $flavorIsWarning()',
		'[class.border-warn]': '!$disabled() && $flavorIsWarning()',
		'[class.fc-200]': '$disabled()',
		'[class]': '$sizeClasses()',
		'[attr.disabled]': '$disabled() ? "true" : null',
		style: '--spacing: 8px; transition: background-color 300ms, color 300ms, border-color: 300ms;',
	},
})
export class ButtonOutlinedDirective {
	public readonly $size = input<ButtonSize>('M', { alias: 'size' });
	public readonly $flavor = input<FilledFlavor | `${FilledFlavor}`>(FilledFlavor.DEFAULT, {
		alias: 'flavor',
	});

	protected readonly $flavorIsWarning = computed(() => {
		return this.$flavor() === FilledFlavor.WARNING;
	});

	public readonly $flavorIsDefault = computed(() => {
		return this.$flavor() === FilledFlavor.DEFAULT;
	});

	public readonly $disabled = input<boolean, boolean | 'true' | 'false'>(false, {
		alias: 'disabled',
		transform: (value) => {
			return `${value}` === `true`;
		},
	});

	protected readonly $sizeClasses = computed(() => {
		const size = this.$size();
		return BUTTON_CLASS_BY_SIZE[size] ?? '';
	});
}
